<template>
  <div class="hospitalFrame">
    <van-row class="login">
      <van-col>
        <van-row style="margin-bottom:2rem">登录页</van-row>

        <van-row style="margin-bottom:1rem">
          <van-field
            style="font-size: 2rem;padding-top: 1rem;"
            label="用户名"
            v-model="data.login_name"
            placeholder="用户名"
            :rules="[{ required: true, message: '请填写 用户名' }]"
          />
        </van-row>

        <van-row>
          <van-field
            style="font-size: 2rem;padding-top: 1rem;"
            v-model="data.pwd"
            type="password"
            label="密码"
            placeholder="密码"
            :rules="[{ required: true, message: '请填写 密码' }]"
          />
        </van-row>

        <van-row
          v-if="errMsg"
          class="err"
        ><span>{{errMsg}}</span>
        </van-row>
        <van-row style="margin-top:2rem">
          <van-button
            style="font-size: 2rem;height:4rem"
            type="primary"
            block
            @click="login()"
            :loading="loading"
            loading-type="spinner"
          >登录</van-button>
        </van-row>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import util from '@/api/util.js';
import server from '@/api/login.js';
export default {
  data () {
    return {
      isSMS: false,
      data: {
        login_name: '',
        pwd: '',
        Code: ''
      },
      errMsg: '',
      loading: false,
      checking: false,
      time: 0,
      systemInfo: {},
      bCheckUser: false
    }
  },
  created () {
  },
  mounted () {
    util.removeStorage('token')
    util.removeStorage('USERDATA')
  },
  methods: {
    // 切换登录方式
    clickSMS () {
      this.isSMS = !this.isSMS
    },
    login () {
      // if (!this.data.login_name) {
      //   this.$s
      //   util.showMsg('请填写 手机号码')
      //   return
      // }
      // if (this.isSMS && !this.data.Code) {
      //   util.showMsg('请填写 验证码')
      //   return
      // }
      // if (!this.isSMS && !this.data.pwd) {
      //   util.showMsg('请填写 密码')
      //   return
      // }
      // if (!this.bCheckUser) {
      //   util.showMsg('请阅读并同意 用户隐私政策')
      //   return
      // }
      this.loading = true
      this.errMsg = ''
      const request = this.isSMS ? server.LoginByCode({
        phoneNum: this.data.login_name,
        Code: this.data.Code
      }) : server.login(this.data)
      request.then((res) => {
        this.loading = false
        if (res.isSuccess) {
          util.setStorage('USERDATA', res.data)
          util.setStorage('token', res.data.token)
          if (res.data.userType == 5 || res.data.userType == 6) {
            util.router("/fb")
          } else {
            util.router("/doctors")
          }
        } else {
          this.errMsg = res.msg
        }
      }).catch(err => {
        console.log(err);
      })
    },
  }
};
</script>
<style scoped>
.hospitalFrame {
  background: rgb(65, 73, 88);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 6rem;
  color: #fff;
  font-size: 4rem;
}
.login {
  text-align: center;
  margin-top: calc(5vw);
}
.err {
  font-size: 2rem;
  color: red;
}
</style>
